import type { ReactNode } from 'react';
import { HotkeysProvider } from 'react-hotkeys-hook';

export function ShortcutsProvider({ children }: { children: ReactNode }) {
  return <HotkeysProvider initiallyActiveScopes={['global', 'editor']}>{children}</HotkeysProvider>;
}
